import { typedAction } from "../../../helpers/redux.helper";
import { SET_IS_REGISTERED_ORG, SET_LOADING_ORG, SET_ORGANISATION_DATA } from './organisation.constant';

export const setIsRegisteredOrg = (isRegistedOrg: boolean) => {
  return typedAction(SET_IS_REGISTERED_ORG, isRegistedOrg);
};

export const setLoadingOrg = (isLoading: boolean) => {
  return typedAction(SET_LOADING_ORG, isLoading);
};

export const setOrganisationData = (orgData: OrgData) => {
  return typedAction(SET_ORGANISATION_DATA, orgData);
};